//输入方法检验工具类
const regex = {
    validateName: /^(?!·)(?!.*·$)(?!.*··)[\u4e00-\u9fa5·]+$/,
    validateUsername: /^[a-zA-Z0-9_-]+$/,
    validateNickname: /^[a-zA-Z0-9\u4e00-\u9fa5_]+$/,
    validateIdcard: /^[1-9][0-9]{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}([0-9]|[Xx])$/,
    validateOfficer: /^军\d{7}$/,
    validatePassport: /^[A-Za-z]{1}\d{8}$|^[A-Za-z]{2}\d{7}$/,
    validateEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    validatePhone: /^((13[0-9])|(14[1|4|5|6|7|8|9])|(15([0|1|2|3|5|6|7|8|9]))|(16[2|5|6|7])|(17[0|1|2|3|5|6|7|8])|(18[0-9])|(19[1|8|9]|190|192|196|197))\d{8}$/,
    validateSocialCode: /^[1-9]{1}[0-9A-Z]{17}$/,
    validateHkTravel: /^[HM]\d{8}$/,
    validateTWTravel: /^\d{8}$/,
    validateTel: /^\d{3,4}-\d{7,8}$/,
    validateForeignerIdcard: /^[A-Z]{3}\d{12}$|^[A-Z]{3}\d{15}$/,
    validateAdmissionCard: /^[A-Za-z0-9_-]{1,20}$/,
    validateBankCard: /^\d{16,19}$/,
    validateCarNumber: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/,
    validateSmsCode: /^\d+$/,
    validateAdress: /^[\u4e00-\u9fa5A-Za-z0-9-]+$/,
    validateAge: /^[1-9]\d*$/,
    validateCount: /^[+]?\d*\.?\d+$/,
    validateTime: /^\d{4}-\d{2}-\d{2}$/,
    validateWechat: /^[a-zA-Z][a-zA-Z0-9_-]*$/,
    validateQQ: /^[1-9][0-9]*$/,
    validateBook: /^[\u4e00-\u9fa5a-zA-Z0-9《》]*$/,
    validateItemName: /^[\u4e00-\u9fa5a-zA-Z0-9（）]*$/
}
const tool = {
    // 校验中文姓名
    validateName: function (str, num = 25) {
        //num 姓名字符数 默认50
        if (!str) {
            return { result: false, msg: '请输入中文姓名' };
        } else if (str.length > num) {
            return { result: false, msg: `中文姓名最多${num}个字` };
        } else if (!regex.validateName.test(str)) {
            return { result: false, msg: '请输入正确的中文姓名' };
        }
        return { result: true, msg: '' }; // 成功返回
    },
    //校验用户名
    validateUsername: function (str, num = 25) {
        if (!str) {
            return { result: false, msg: '请输入用户名' };
        } else if (str.length > num) {
            return { result: false, msg: `用户名最多${num}个字` };
        } else if (!regex.validateUsername.test(str)) {
            return { result: false, msg: '请输入正确的用户名' };
        }
        return { result: true, msg: '' };
    },
    //校验昵称
    validateNickname: function (str, num = 25) {
        if (!str) {
            return { result: false, msg: '请输入昵称' };
        } else if (str.length > num) {
            return { result: false, msg: `昵称最多${num}个字` };
        } else if (!regex.validateNickname.test(str)) {
            return { result: false, msg: '请输入正确的昵称' };
        }
        return { result: true, msg: '' };
    },
    //校验身份证号
    validateIdcard: function (str) {
        if (!str) {
            return { result: false, msg: '请输入身份证号' };
        } else if (str.length != 18) {
            return { result: false, msg: `身份证号固定为18位` };
        } else if (!regex.validateIdcard.test(str)) {
            return { result: false, msg: '请输入正确的身份证号' };
        }
        return { result: true, msg: '' };
    },
    //校验军官证
    validateOfficer: function (str) {
        if (!str) {
            return { result: false, msg: '请输入军官证号' };
        } else if (str.length != 8) {
            return { result: false, msg: `军官证号固定为8位` };
        } else if (!regex.validateOfficer.test(str)) {
            return { result: false, msg: '请输入正确的军官证号' };
        }
        return { result: true, msg: '' };
    },
    //校验护照号
    validatePassport: function (str) {
        if (!str) {
            return { result: false, msg: '请输入护照号' };
        } else if (str.length != 9) {
            return { result: false, msg: `护照号固定为9位` };
        } else if (!regex.validatePassport.test(str)) {
            return { result: false, msg: '请输入正确的护照号' };
        }
        return { result: true, msg: '' };
    },
    //校验电子邮箱
    validateEmail: function (str, num = 50) {
        if (!str) {
            return { result: false, msg: '请输入电子邮箱' };
        } else if (str.length > num) {
            return { result: false, msg: `电子邮箱最多${num}位` };
        } else if (!regex.validateEmail.test(str)) {
            return { result: false, msg: '请输入正确的电子邮箱' };
        }
        return { result: true, msg: '' };
    },
    //校验手机号
    validatePhone: function (str) {
        if (!str) {
            return { result: false, msg: '请输入手机号' };
        } else if (str.length != 11) {
            return { result: false, msg: `手机号固定为11位` };
        } else if (!regex.validatePhone.test(str)) {
            return { result: false, msg: '请输入正确的手机号' };
        }
        return { result: true, msg: '' };
    },
    //校验统一社会信用代码
    validateSocialCode: function (str) {
        if (!str) {
            return { result: false, msg: '请输入统一社会信用代码' };
        } else if (str.length != 18) {
            return { result: false, msg: `统一社会信用代码固定为18位` };
        } else if (!regex.validateSocialCode.test(str)) {
            return { result: false, msg: '请输入正确的统一社会信用代码' };
        }
        return { result: true, msg: '' };
    },
    //校验港澳居民来往内地通行证号
    validateHkTravel: function (str) {
        if (!str) {
            return { result: false, msg: '请输入港澳居民来往内地通行证号' };
        } else if (str.length != 9) {
            return { result: false, msg: `港澳居民来往内地通行证号固定为9位` };
        } else if (!regex.validateHkTravel.test(str)) {
            return { result: false, msg: '请输入正确的港澳居民来往内地通行证号' };
        }
        return { result: true, msg: '' };
    },
    //校验台湾居民来往大陆通行证号
    validateTWTravel: function (str) {
        if (!str) {
            return { result: false, msg: '请输入台湾居民来往大陆通行证号' };
        } else if (str.length != 8) {
            return { result: false, msg: `台湾居民来往大陆通行证号固定为8位` };
        } else if (!regex.validateTWTravel.test(str)) {
            return { result: false, msg: '请输入正确的台湾居民来往大陆通行证号' };
        }
        return { result: true, msg: '' };
    },
    //校验固定电话
    validateTel: function (str) {
        console.log(str.length)
        if (!str) {
            return { result: false, msg: '请输入固定电话' };
        } else if (str.length < 11 || str.length > 13) {
            return { result: false, msg: `固定电话为11~13位` };
        } else if (!regex.validateTel.test(str)) {
            return { result: false, msg: '请输入正确的固定电话' };
        }
        return { result: true, msg: '' };
    },
    //外国人永久居留身份证号
    validateForeignerIdcard: function (str) {
        if (!str) {
            return { result: false, msg: '请输入外国人永久居留身份证号' };
        } else if (str.length != 15 && str.length != 18) {
            return { result: false, msg: `外国人永久居留身份证号固定为15或18位` };
        } else if (!regex.validateForeignerIdcard.test(str)) {
            return { result: false, msg: '请输入正确的外国人永久居留身份证号' };
        }
        return { result: true, msg: '' };
    },
    //校验准考证号
    validateAdmissionCard: function (str, num = 20) {
        if (!str) {
            return { result: false, msg: '请输入准考证号' };
        } else if (str.length > num) {
            return { result: false, msg: `准考证号最多${num}位` };
        } else if (!regex.validateAdmissionCard.test(str)) {
            return { result: false, msg: '请输入正确的准考证号' };
        }
        return { result: true, msg: '' };
    },
    //校验银行卡号
    validateBankCard: function (str) {
        if (!str) {
            return { result: false, msg: '请输入银行卡号' };
        } else if (str.length < 16 || str.length > 19) {
            return { result: false, msg: `银行卡号为16~19位` };
        } else if (!regex.validateBankCard.test(str)) {
            return { result: false, msg: '请输入正确的银行卡号' };
        }
        return { result: true, msg: '' };
    },
    //校验车牌号
    validateCarNumber: function (str, num = 8) {
        if (!str) {
            return { result: false, msg: '请输入车牌号' };
        } else if (str.length > num) {
            return { result: false, msg: `车牌号最多${num}位` };
        } else if (!regex.validateCarNumber.test(str)) {
            return { result: false, msg: '请输入正确的车牌号' };
        }
        return { result: true, msg: '' };
    },
    //校验短信验证码
    validateSmsCode: function (str, num = 6) {
        if (!str) {
            return { result: false, msg: '请输入短信验证码' };
        } else if (str.length > num) {
            return { result: false, msg: `短信验证码最多${num}位` };
        } else if (!regex.validateSmsCode.test(str)) {
            return { result: false, msg: '请输入正确的短信验证码' };
        }
        return { result: true, msg: '' };
    },
    //校验家庭住址/联系地址
    validateAdress: function (str, num = 50) {
        if (!str) {
            return { result: false, msg: '请输入家庭住址/联系地址' };
        } else if (str.length > num) {
            return { result: false, msg: `家庭住址/联系地址最多${num}个字` };
        } else if (!regex.validateAdress.test(str)) {
            return { result: false, msg: '请输入正确的家庭住址/联系地址' };
        }
        return { result: true, msg: '' };
    },
    //校验评论评价、意见反馈、留言内容等多行输入
    validateTextArea: function (str, num = 250) {
        if (!str) {
            return { result: false, msg: '请输入内容' };
        } else if (str.length > num) {
            return { result: false, msg: `内容最多${num}个字` };
        }
        return { result: true, msg: '' };
    },
    //校验年龄
    validateAge: function (str, num = 3) {
        if (!str) {
            return { result: false, msg: '请输入年龄' };
        } else if (str.length > num) {
            return { result: false, msg: `年龄最多${num}位` };
        } else if (!regex.validateAge.test(str)) {
            return { result: false, msg: '请输入正确的年龄' };
        }
        return { result: true, msg: '' };
    },
    //校验日期
    validateTime: function (str, num = 10) {
        if (!str) {
            return { result: false, msg: '请输入日期' };
        } else if (str.length > num) {
            return { result: false, msg: `日期最多${num}个字` };
        } else if (!regex.validateTime.test(str)) {
            return { result: false, msg: '请输入正确的日期' };
        }
        return { result: true, msg: '' };
    },
    //校验长度、面积、体积、时长、温度、速度、功率、存储等计量单位
    validateCount: function (str, num = 20) {
        if (!str) {
            return { result: false, msg: '请输入计量单位' };
        } else if (str.length > num) {
            return { result: false, msg: `计量单位最多${num}位` };
        } else if (!regex.validateCount.test(str)) {
            return { result: false, msg: '请输入正确的计量单位' };
        }
        return { result: true, msg: '' };
    },
    //校验微信号
    validateWechat: function (str) {
        if (!str) {
            return { result: false, msg: '请输入微信号' };
        } else if (str.length < 6 || str.length > 20) {
            return { result: false, msg: `微信号为6~20位` };
        } else if (!regex.validateWechat.test(str)) {
            return { result: false, msg: '请输入正确的微信号' };
        }
        return { result: true, msg: '' };
    },
    //校验QQ号
    validateQQ: function (str) {
        if (!str) {
            return { result: false, msg: '请输入QQ号' };
        } else if (str.length < 5 || str.length > 10) {
            return { result: false, msg: `QQ号为5~10位` };
        } else if (!regex.validateQQ.test(str)) {
            return { result: false, msg: '请输入正确的QQ号' };
        }
        return { result: true, msg: '' };
    },
    //校验书籍名
    validateBook: function (str, num = 25) {
        if (!str) {
            return { result: false, msg: '请输入书籍名' };
        } else if (str.length > num) {
            return { result: false, msg: `书籍名最多${num}个字` };
        } else if (!regex.validateBook.test(str)) {
            return { result: false, msg: '请输入正确的书籍名' };
        }
        return { result: true, msg: '' };
    },
    //校验名称
    validateItemName: function (str, num = 25) {
        if (!str) {
            return { result: false, msg: '请输入名称' };
        } else if (str.length > num) {
            return { result: false, msg: `名称最多${num}个字` };
        } else if (!regex.validateItemName.test(str)) {
            return { result: false, msg: '请输入正确的名称' };
        }
        return { result: true, msg: '' };
    },
    // 姓名脱敏
    desensitizationName: function (name) {
        if (!name) return '';
        const length = name.length;
        if (length === 2) {
            // 两个字，隐藏第一个字
            return '*' + name[1];
        } else if (length === 3) {
            // 三个字，隐藏第一个字
            return '*' + name.slice(1);
        } else if (length > 3 && length <= 6) {
            // 六个字以下（含），三个字以上，只显示最后两个字
            return '*'.repeat(length - 2) + name.slice(-2);
        } else if (length > 6) {
            // 六个字以上的，显示前第一个字和最后两个字
            return name[0] + '*'.repeat(length - 3) + name.slice(-2);
        }
        return name;
    },
    // 银行卡
    desensitizationBank: function (str) {
        if (str.length <= 8) {
            // 如果字符串长度小于等于8，直接返回原字符串
            return str;
        }
        // 获取前四位和后四位
        const firstFour = str.slice(0, 4);
        const lastFour = str.slice(-4);
        // 中间部分用星号替换
        const middle = '*'.repeat(str.length - 8);
        // 返回脱敏后的字符串
        return firstFour + middle + lastFour;
    },
    // 卡号
    desensitizationCardNum: function (str) {
        const length = str.length;
        if (length <= 3) {
            // 如果字符串长度小于等于3，直接返回原字符串
            return str;
        }
        // 计算前1/3和后1/3的长度
        const frontLength = Math.ceil(length / 3); // 前部分长度
        const rearLength = Math.floor(length / 3); // 后部分长度
        // 获取前1/3和后1/3的内容
        const front = str.slice(0, frontLength);
        const rear = str.slice(-rearLength);
        // 中间部分用*号替换
        const middle = '*'.repeat(length - frontLength - rearLength);
        // 返回脱敏后的字符串
        return front + middle + rear;
    },
    //身份证脱敏
    desensitizationId: function (id) {
        if (!id || id.length < 2) return id; // 如果证件号为空或长度不足，直接返回
        // 显示第一位 + '*'（实际位数） + 最后一位
        const firstChar = id[0]; // 第一位
        const lastChar = id[id.length - 1]; // 最后一位
        const maskedPart = '*'.repeat(id.length - 2); // 中间部分用 '*' 代替

        return firstChar + maskedPart + lastChar;
    },
    // 手机号脱敏大陆
    desensitizationPhone: function (phone) {
        if (!phone || phone.length < 5) return phone; // 如果手机号为空或长度不足，直接返回

        // 显示前 3 位 + '*'（中间部分） + 后 2 位
        const firstThree = phone.slice(0, 3); // 前 3 位
        const lastTwo = phone.slice(-2); // 后 2 位
        const middleStars = '*'.repeat(phone.length - 5); // 中间部分用 '*' 代替

        return firstThree + middleStars + lastTwo;
    },
    // 手机号脱敏香港、澳门
    desensitizationPhoneXG: function (phone) {
        if (!phone || phone.length < 5) return phone; // 如果手机号为空或长度不足，直接返回

        // 显示前 3 位 + '*'（中间部分） + 后 2 位
        const firstThree = phone.slice(0, 2); // 前 3 位
        const lastTwo = phone.slice(-2); // 后 2 位
        const middleStars = '*'.repeat(phone.length - 4); // 中间部分用 '*' 代替

        return firstThree + middleStars + lastTwo;
    },
    // 手机号脱敏台湾
    desensitizationPhoneTW: function (phone) {
        if (!phone || phone.length < 5) return phone; // 如果手机号为空或长度不足，直接返回

        // 显示前 3 位 + '*'（中间部分） + 后 2 位
        const firstThree = phone.slice(0, 2); // 前 3 位
        const lastTwo = phone.slice(-3); // 后 2 位
        const middleStars = '*'.repeat(phone.length - 5); // 中间部分用 '*' 代替

        return firstThree + middleStars + lastTwo;
    },
    // 固定电话
    desensitizationTel: function (phone) {
        if (!phone) return phone; // 如果电话为空，直接返回
        // 判断是否包含区号（假设区号以括号或横线分隔）
        const hasAreaCode = /^(\d{3,4}-|\d{3,4}\()/.test(phone);
        let areaCode = '';
        let mainNumber = phone;
        // 提取区号
        if (hasAreaCode) {
            const areaCodeMatch = phone.match(/^(\d{3,4})[-()]/);
            if (areaCodeMatch) {
                areaCode = areaCodeMatch[1] + '*'; // 保留区号和分隔符
                mainNumber = phone.slice(areaCode.length); // 剩余部分为主号码
            }
        }
        // 显示后 4 位，其余用 '*' 代替
        const lastFour = mainNumber.slice(-4); // 后 4 位
        const maskedPart = '*'.repeat(mainNumber.length - 4); // 中间部分用 '*' 代替
        return areaCode + maskedPart + lastFour;
    },
    // 邮箱
    desensitizationEmail: function (email) {
        if (!email) return email; // 如果邮箱为空，直接返
        const atIndex = email.indexOf('@'); // 找到 @ 的位置
        if (atIndex === -1) return email; // 如果没有 @，直接返回原邮箱

        const prefix = email.slice(0, atIndex); // @ 前面的部分
        const suffix = email.slice(atIndex); // @ 及后面的部分

        // 显示前 3 位 + '***' + @ 后面的部分
        const visiblePrefix = prefix.slice(0, 3); // 前 3 位
        const maskedPrefix = visiblePrefix + '***'; // 前 3 位 + ***

        return maskedPrefix + suffix;
    },
    desensitizationAddress: function (address) {
        // 匹配省市区信息（假设地址格式为 "省 市 区 详细地址"）
        const regex = /^(.*?(省|自治区|市))?(.*?(市|自治州|地区))?(.*?(区|县|市))/;
        const match = address.match(regex);

        if (match) {
            // 提取省、市、区信息
            const province = match[1] || '';
            const city = match[3] || '';
            const district = match[5] || '';
            // 组合脱敏后的地址
            return `${province.trim()} ${city.trim()} ${district.trim()} ******`;
        }

        // 如果无法匹配省市区，返回原始地址或处理后的默认值
        return address;
    },
    desensitizationQQ: function (str) {
        if (str.length <= 2) {
            return str; // 如果字符串长度小于等于2，直接返回原字符串
        }

        const firstChar = str[0];
        const lastChar = str[str.length - 1];
        const maskedPart = '*'.repeat(str.length - 2);

        return firstChar + maskedPart + lastChar;
    },
    desensitizationDate: function (str) {
        const maskedPart = '*'.repeat(str.length);
        return maskedPart;
    },
    desensitizationTime: function () {
        const now = new Date();
        const hour = now.getHours();
        if (hour >= 5 && hour < 12) {
            return "早上好！";
        } else if (hour >= 12 && hour < 14) {
            return "中午好！";
        } else if (hour >= 14 && hour < 18) {
            return "下午好！";
        } else {
            return "晚上好！";
        }
    }
};

export {
    tool
}
